export default {
	sec_01: {
		title: {
			one: '편안하게 ',
			two: '요청',
		},
		desc: {
			one: '친구와 가족은 알림 없이',
			two: '암호화폐를 요청 하실 수 있습니다.',
		},
		btn: {
			one: '암호화폐요청',
			two: '앱 다운로드',
		},
	},
	sec_09: {
		title: {
			one: '편안한 자산',
			two: '요청 서비스',
		},
		one: {
			desc: {
				one: '편안하고 사용이 쉬운 요청',
				two: '인스턴트 양방향 메시징',
			},
		},
	},
	sec_03: {
		one: {
			title: {
				one: '번거로움 없이',
				two: '무료 요청 서비스',
			},
			desc: {
				one: '친구에게 쉽게 돈을 요청하고 기다리면',
				two: '자동으로 입금이 됩니다.',
			},
		},
		two: {
			title: {
				one: '쉬운 설정',
			},
			desc: {
				one: '친구가 JP WORLD PAY 계정이 없는 경우',
				two: '몇 분 안에 회원가입만 하면 끝.',
			},
		},
		three: {
			title: {
				one: 'JP WORLD PAY 사용자를 선택하고',
				two: '요청한 금액을 입력하세요.',
			},
			desc: {
				one: '순식간에 JP WORLD PAY 자산요청 링크를 만들어 매일매일',
				two: '암호화폐를 받는 일을 간단하게 만들 수 있습니다.',
			},
			btn: {
				one: 'JP WORLD PAY 링크 만들기',
			},
		},
	},
	sec_05: {
		title: '급여를 보내는 것은 쉽습니다.',
		desc: {
			one: '앱을 열고 지불 받기를 선택하십시오.',
		},
	},
};
